import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const playAudio = () => {
  const fired = new Audio("https://www.gisbefreit.at/js/files/fired.mp3");
  fired.volume = 0.5;

  fired.play();
};

function Right() {
  const selectShareInput = (e) => {
    e.target.select();
  };

  useEffect(() => {
    document.querySelector("input.search").addEventListener("keyup", (e) => {
      if (e.target.value.length == 1) {
        e.target.value = "D";
      }
      if (e.target.value.length == 2) {
        e.target.value = "Do";
      }
      if (e.target.value.length == 3) {
        e.target.value = "Don";
      }
      if (e.target.value.length == 4) {
        e.target.value = "Dona";
      }
      if (e.target.value.length == 5) {
        e.target.value = "Donal";
      }
      if (e.target.value.length == 6) {
        e.target.value = "Donald";
      }
      if (e.target.value.length == 7) {
        e.target.value = "Donald ";
      }
      if (e.target.value.length == 8) {
        e.target.value = "Donald T";
      }
      if (e.target.value.length == 9) {
        e.target.value = "Donald Tr";
      }
      if (e.target.value.length == 10) {
        e.target.value = "Donald Tru";
      }
      if (e.target.value.length == 11) {
        e.target.value = "Donald Trum";
      }
      if (e.target.value.length == 12) {
        e.target.value = "Donald Trump";
      }
      if (e.target.value.length > 12) {
        e.target.value = "Donald Trump";
      }
    });
  }, []);

  return (
    <div className="right">
      <input
        className="search"
        placeholder="Search Trumper..."
        type="text"
        name=""
        id=""
      />

      <div className="whoToFollow">
        <div className="header">Who to follow</div>
        <div className="item">
          <Link to="/realdonaldtrump">
            <div className="left">
              <img
                src="https://static01.nyt.com/newsgraphics/2019/08/01/candidate-pages/3b31eab6a3fd70444f76f133924ae4317567b2b5/trump-circle.png"
                alt=""
              />
              <div className="userInfo">
                <p>Donald J. Trump</p>
                <span>@realdonaldtrump</span>
              </div>
            </div>
          </Link>
          <div
            className="followBtn"
            onClick={() => {
              playAudio();
            }}
          >
            Unfollow
          </div>
        </div>
      </div>

      <div className="shareThis">
        <div className="inside">
          <p>
            <i class="bi bi-share"></i> Share this website:
          </p>
          <input
            onClick={selectShareInput}
            readOnly
            value="https://trumper-2021.web.app"
            type="url"
            name=""
            id=""
          />
        </div>
      </div>

      <p class="ownerNotice">
        © Copyright: Alexander Jakob |{" "}
        <a href="mailto:jakobalex@ymail.com">E-Mail</a>
      </p>
    </div>
  );
}

export default Right;
